import { Component, OnInit } from "@angular/core";
import { ConstantConfigurationService } from "../../shared/services/constant-configuration/constant-configuration.service";
import { first } from "rxjs/operators";

@Component({
  selector: "app-define-question-type",
  templateUrl: "./define-question-type.component.html",
  styleUrls: ["./define-question-type.component.scss"]
})
export class DefineQuestionTypeComponent implements OnInit {
  question: any;

  constructor(private constantApi: ConstantConfigurationService) {}

  ngOnInit() {
    this.getQuestion();
  }
  getQuestion() {
    this.constantApi
      .getConstantValue("QUESTIONTYPE")
      .pipe(first())
      .subscribe(res => {
        if (res) {
          this.question = res;
        }
      });
  }
}
